/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 11:35 AM
 *
 */

import ImageAvatar from 'components/ImageAvatar/ImageAvatar';

export default ImageAvatar;
